import "./CategoriesPage.scss";
import Categories from "../Home/Categories/Categories";
const CategoriesPage = ({ products, categories }) => {
  return (
    <div>
      <div className="categories-container">
        <div className="main-container">
          <div className="main-content">
            <div className="layout">
              <Categories
                headingText="Popular Brands"
                categories={categories}
                products={products}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesPage;
